import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { forkJoin, Subject } from 'rxjs';
import { Orthophoto } from 'src/app/bo/orthophoto';
import { HttpService } from 'src/app/services/http.service';
import { Site } from '../../../bo/site';
import { FonctionsService } from '../../../services/fonctions-partagees.service';
import { UploadGeotiffService } from '../../../services/upload-geotiff.service';
import { KeycloakUtilisateur } from 'src/app/bo/user/user';

@Component({
  selector: 'app-site-orthophotos-modale',
  templateUrl: './site-orthophotos-modale.component.html',
  styleUrls: ['./site-orthophotos-modale.component.scss'],
  standalone: false
})
export class SiteOrthophotosModaleComponent implements OnInit, OnDestroy {
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  modaleFermee = new EventEmitter<boolean>();
  unsubscribe$ = new Subject<void>();
  orthophoto: Orthophoto;
  orthophotoTemp: Orthophoto;
  listeOrthophotos: Orthophoto[];
  utilisateur: KeycloakUtilisateur;
  site: Site;
  fichierTelechargement: File;
  upload: boolean; //différencier la modif de l'upload
  poidsFichier = 0;
  erreurExtension = false;
  nomInvalide = false;
  ordreInvalide = false;
  fichierNonSelectionne = false;

  constructor(private readonly geotiffService: UploadGeotiffService, public bsModalRef: BsModalRef, public fonctionsService: FonctionsService,
    private readonly http: HttpService) { }

  ngOnInit(): void {
    this.orthophotoTemp = new Orthophoto;
    if (this.upload) {
      this.orthophoto = new Orthophoto();
      this.orthophotoTemp.isActif = true;
    } else {
      Object.assign(this.orthophotoTemp, this.orthophoto);
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSubmit(): void {
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      if (this.fichierTelechargement) {
        this.geotiffService.uploadGeotiff(this.fichierTelechargement, this.poidsFichier, this.orthophotoTemp.name, this.orthophotoTemp.ordre);
        this.fonctionsService.loading_screen(false);
        this.modaleFermee.emit(true);
        this.bsModalRef.hide();
      }
      else if (!this.upload) {
        if (this.orthophoto.isActif != this.orthophotoTemp.isActif) {
          this.listeOrthophotos.find(e => e.name === this.orthophoto.name).isActif = this.orthophotoTemp.isActif;
          this.listeOrthophotos.find(e => e.name === this.orthophoto.name).ordre = this.orthophotoTemp.ordre;
          var modifActive = this.http.put('Sites/' + this.site.siteId + '/LayerActive', this.orthophotoTemp);
          var modifOrder = this.http.put('Sites/' + this.site.siteId + '/LayerOrder', this.listeOrthophotos);
          forkJoin([modifActive, modifOrder]).subscribe(resultat => {
            this.fonctionsService.loading_screen(false);
            this.fonctionsService.launch_toast(true);
            this.modaleFermee.emit(true);
            this.bsModalRef.hide();
          },
            (error) => {
              console.log(error);
              this.fonctionsService.loading_screen(false);
              this.fonctionsService.launch_toast(false);
              this.modaleFermee.emit(true);
              this.bsModalRef.hide();
            }
          );
        }
        if (this.orthophoto.ordre != this.orthophotoTemp.ordre) {
          this.listeOrthophotos.find(e => e.name === this.orthophoto.name).ordre = this.orthophotoTemp.ordre;
          this.http.put('Sites/' + this.site.siteId + '/LayerOrder', this.listeOrthophotos).subscribe(resultat => {
            this.fonctionsService.loading_screen(false);
            this.fonctionsService.launch_toast(true);
            this.modaleFermee.emit(true);
            this.bsModalRef.hide();
          },
            (error) => {
              this.fonctionsService.loading_screen(false);
              this.fonctionsService.launch_toast(false);
              this.modaleFermee.emit(true);
              this.bsModalRef.hide();
            }
          );
        }
        else {
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
          this.modaleFermee.emit(true);
          this.bsModalRef.hide();
        }
      }
    }
  }

  validationFormulaire() {
    this.nomInvalide = this.fonctionsService.stringEstVide(this.orthophotoTemp.name);
    this.ordreInvalide = this.orthophotoTemp.ordre === null || this.orthophotoTemp.ordre === undefined || this.orthophotoTemp.ordre.toString().trim() === '';
    if (this.upload) {
      this.fichierNonSelectionne = this.fichierTelechargement === null || this.fichierTelechargement === undefined;
    }
    return !this.nomInvalide && !this.ordreInvalide && !this.fichierNonSelectionne;
  }

  ouvrirExplorateur() {
    this.erreurExtension = false;
    document.getElementById('inputFile').click();
    const input = document.querySelector<HTMLInputElement>('#inputFile');
    input.addEventListener('change', () => {
      if (input.files && input.files.length) {
        if (!input.files[0].name.includes(".tif") && !input.files[0].name.includes(".tiff")) {
          this.erreurExtension = true;
        }
        else {
          this.fichierTelechargement = input.files[0];
          this.poidsFichier = input.files[0].size;
        }
      }
    });
  }

  enleverFichier() {
    this.poidsFichier = 0;
    this.fichierTelechargement = null;
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel.show();
    }
    else this.bsModalRef.hide();
  }

  diff() {
    if (!this.upload) {
      return this.orthophoto.name !== this.orthophotoTemp.name ||
        this.orthophoto.isActif !== this.orthophotoTemp.isActif ||
        this.orthophoto.ordre !== this.orthophotoTemp.ordre;
    } else {
      return this.orthophoto.name ||
        this.orthophoto.ordre;
    }
  }

  hideModalCancel() {
    this.modalConfirmCancel.hide();
  }

  showConfirmSuppr() {
    this.modalConfirmSuppr.show();
  }

  hideConfirmSuppr() {
    this.modalConfirmSuppr.hide();
  }

  deleteLayer() {
    this.fonctionsService.loading_screen(true);
    this.http.put('Sites/' + this.site.siteId + '/DeleteLayer', this.orthophoto).subscribe(resultat => {
      this.fonctionsService.loading_screen(false);
      this.fonctionsService.launch_toast(true);
      this.bsModalRef.hide();
      this.modaleFermee.emit(true);
      this.modalConfirmSuppr.hide();
    },
      (error) => {
        this.fonctionsService.loading_screen(false);
        this.fonctionsService.launch_toast(false);
        this.bsModalRef.hide();
        this.modaleFermee.emit(true);
        this.modalConfirmSuppr.hide();
      }
    );
  }
}
